import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { SneakLaunch } from './sneaker-release.type';

dayjs.extend(utc);

export const formatDate = (date?: string, format = 'YYYY-MM-DD') => {
    if (!date) return '';
    return dayjs.utc(date).format(format);
};

export const transformReleaseProduct = (product: SneakLaunch): SneakLaunch => {
    return {
        ...product,
        id: product?.id,
        title: product?.title,
        releaseDate: product?.releaseDate,
        pageTheme: product?.pageTheme,
        color: product?.color,
        styleCode: product?.styleCode,
        retail: product?.retail,
        htmlContent: product?.htmlContent,
        slug: product?.slug
    };
};
